import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import VendorScope3Form from "../dashboard/vendors/VendorScope3Form";
import VendorStatusBadge from "../dashboard/vendors/VendorStatusBadge";

function vendorHeaders() {
  const t = localStorage.getItem("vendorAccessToken");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

const VendorPortalPage = () => {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [assignments, setAssignments] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const load = async () => {
    const token = localStorage.getItem("vendorAccessToken");
    if (!token) {
      navigate("/vendor/login");
      return;
    }
    try {
      const { data: m } = await axios.get("/api/vendor/me", { headers: vendorHeaders() });
      if (m.status && m.vendor) setMe(m.vendor);
      const { data: a } = await axios.get("/api/vendor/assignments", { headers: vendorHeaders() });
      if (a.status && a.assignments) {
        setAssignments(a.assignments);
        if (a.assignments.length && !selectedId) setSelectedId(a.assignments[0].id);
      }
    } catch (e) {
      localStorage.removeItem("vendorAccessToken");
      navigate("/vendor/login");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    localStorage.removeItem("vendorAccessToken");
    navigate("/vendor/login");
  };

  if (!me) {
    return (
      <div className="min-h-screen d-flex align-items-center justify-content-center">
        <p className="text-muted">Loading…</p>
      </div>
    );
  }

  return (
    <div className="container py-4" style={{ maxWidth: 1100 }}>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
        <div>
          <h1 className="h4 mb-0">Disclosures</h1>
          <p className="text-muted small mb-0">
            {me.name} · {me.email}
          </p>
        </div>
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={logout}>
          Sign out
        </button>
      </div>

      {assignments.length === 0 ? (
        <div className="alert alert-info">
          No disclosure forms have been assigned yet. Your customer will notify you when something is ready.
        </div>
      ) : (
        <div className="row g-3">
          <div className="col-md-4">
            <div className="list-group">
              {assignments.map((as) => (
                <button
                  type="button"
                  key={as.id}
                  className={`list-group-item list-group-item-action text-start d-flex justify-content-between align-items-center gap-2 ${selectedId === as.id ? "active" : ""}`}
                  onClick={() => setSelectedId(as.id)}
                >
                  <span className="text-truncate">
                    Category {as.scope3Category} · {as.reportingYear}
                  </span>
                  <VendorStatusBadge status={as.status} variant="inline" />
                </button>
              ))}
            </div>
          </div>
          <div className="col-md-8">
            <div className="card shadow-sm">
              <div className="card-body">
                {selectedId ? (
                  <VendorScope3Form
                    assignmentId={selectedId}
                    useVendorAuth
                    onSaved={() => {
                      load();
                    }}
                  />
                ) : (
                  <p className="text-muted small">Select a form.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorPortalPage;
